import React from "react";
import { HeaderSection, MainContainer } from "../index.styled";
import { ReactComponent as SearchHistoryIcon } from "../../../Assets/Icons/SearchHistory.svg";
import { ReactComponent as EditIcon } from "../../../Assets/Icons/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../Assets/Icons/DeleteIcon.svg";
import styled from "styled-components";
import { viewSizeCalculator } from "../../../utils";
import Info from "../../Info";
// import { Partition } from "../../FilterComp/index.styled";

const SearchHistory = ({
  data,
  reference,
  searchData,
  handleEditItem,
  handleDeleteItem,
  selectedSearchItemId,
  handleSelectSearchItem,
}) => {
  return (
    <MainContainer ref={reference}>
      <HeaderSection>
        <SearchHistoryIcon style={{ width: "1.1rem" }} />
        {data.category}
      </HeaderSection>
      <ContentWrapper>
        <RowContainer width={100}>
          <h4>Sr. Saved Searches</h4>
          {searchData.map((item, index) => (
            <SearchItem
              key={item?.id}
              hasBorder={index !== 0}
              onClick={() => handleSelectSearchItem(item.id)}
              isSelected={item.id === selectedSearchItemId}
            >
              <div className="search-item">
                <span>{index + 1}</span>
                <span>{item.title}</span>
              </div>
              <div className="search-item">
                <Info
                  showArrow={false}
                  config={{
                    tooltipText: "Edit",
                    position: "top",
                  }}
                >
                  <EditIcon onClick={(e) => handleEditItem(e, item.id)} />
                </Info>
                <Info
                  showArrow={false}
                  config={{
                    tooltipText: "Delete",
                    position: "top",
                  }}
                >
                  <DeleteIcon onClick={(e) => handleDeleteItem(e, item.id)} />
                </Info>
              </div>
            </SearchItem>
          ))}
        </RowContainer>
      </ContentWrapper>
    </MainContainer>
  );
};

export default SearchHistory;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${viewSizeCalculator(1.25)};
`;

const RowContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: ${({ wrap }) => (wrap ? "wrap" : "no-wrap")};
  width: 100%;

  h4 {
    font-size: ${() => `${viewSizeCalculator(0.8125)}`};
    color: #969696;
    font-weight: 600;
    margin-bottom: ${viewSizeCalculator(0.8)};
    padding: 0 ${viewSizeCalculator(0.8)};
  }

  .search-item {
    display: flex;
    gap: ${viewSizeCalculator(0.78)};
    cursor: pointer;

    svg {
      width: ${viewSizeCalculator(1.4)};
    }
  }
`;

const SearchItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${viewSizeCalculator(3.2)};
  padding: 0 ${viewSizeCalculator(0.8)};
  border-top: ${({ hasBorder }) =>
    hasBorder ? `${viewSizeCalculator(1.5, true)} solid #ebebeb` : "none"};
  transition: background-color 0.3s ease;
  cursor: pointer;

  ${({ isSelected }) =>
    isSelected &&
    `
    background-color: #f5f5f5;
    border-radius: ${viewSizeCalculator(1.2)};
    border-top: ${viewSizeCalculator(1.5, true)} solid #ebebeb;
    border-bottom: ${viewSizeCalculator(1.5, true)} solid #ebebeb;
  `}

  ${({ isSelected }) =>
    isSelected &&
    `
    & + div {
      border-top: none;
    }
  `}

  &:hover {
    background-color: #f5f5f5;
    border-radius: ${viewSizeCalculator(1.2)};
    border-top: ${viewSizeCalculator(1, true)} solid #ebebeb;
    border-bottom: ${viewSizeCalculator(1, true)} solid #ebebeb;
  }

  &:hover + & {
    border-top: none;
  }

  span {
    font-size: ${() => `${viewSizeCalculator(0.8125)}`};
    font-weight: 500;
  }
`;
